import axios from "axios"

if (process.env.NODE_ENV !== "production") {
  axios.defaults.baseURL = "http://localhost:3030"
}

// MARK: State
const state = () => ({
  burgstrasse: {
    info: {},
    data: {
      time: {
        time: "",
      },
      departures: [],
    },
  },
  hammerbrook: {
    info: {},
    data: {
      time: {
        time: "",
      },
      departures: [],
    },
  },
})

// MARK: Getters
const getters = {
  stationBurgstrasseData(state) {
    return state.burgstrasse
  },
  stationHammerbrookData(state) {
    return state.hammerbrook
  },
}

// MARK: Actions
const actions = {
  async getBurgstrasse({ commit }) {
    const response = await axios
      .get("/api/hvvstations/burgstrasse", {
        withCredentials: false,
        credentials: "include",
        headers: {
          "x-access-token": localStorage.getItem("access_token"),
        },
      })
      .catch((err) => {
        console.log("err:", err)
      })

    if (response && response.data) {
      commit("setBurgstrasse", response.data)
    }
  },
  async getHammerbrook({ commit }) {
    const response = await axios
      .get("/api/hvvstations/hammerbrook", {
        withCredentials: false,
        credentials: "include",
        headers: {
          "x-access-token": localStorage.getItem("access_token"),
        },
      })
      .catch((err) => {
        console.log("err:", err)
      })

    if (response && response.data) {
      commit("setHammerbrook", response.data)
    }
  },
}

// MARK: Mutations
const mutations = {
  setBurgstrasse(state, data) {
    state.burgstrasse = data
  },
  setHammerbrook(state, data) {
    state.hammerbrook = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
